import { Box, CircularProgress, Typography } from '@mui/material';
import RouletteContentRouletteTabChart from '../../../../components/pointhome/roulette/content/RouletteContentRouletteTabChart';
import RouletteContentRouletteTabTable from '../../../../components/pointhome/roulette/content/RouletteContentRouletteTabTable';
import type { RouletteTabChartDatum } from '../../../../components/pointhome/roulette/content/RouletteContentRouletteTabChart';
import type { RouletteTabTableRow } from '../../../../components/pointhome/roulette/content/RouletteContentRouletteTabTable';

type Props = {
  loading: boolean;
  error: string | null;
  chartData?: RouletteTabChartDatum[];
  tableRows?: RouletteTabTableRow[];
};

export default function TabRoulette({ loading, error, chartData, tableRows }: Props) {
  if (error) {
    return (
      <Typography color="error" variant="body2" sx={{ mb: 2 }}>
        {error}
      </Typography>
    );
  }
  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 3 }}>
        <CircularProgress size={32} />
      </Box>
    );
  }

  return (
    <>
      <RouletteContentRouletteTabChart data={chartData} />
      <RouletteContentRouletteTabTable rows={tableRows} />
    </>
  );
}
